import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface CommunityTopic {
  id: string;
  title: string;
  description: string | null;
  tags: string[] | null;
  thumbnail_url: string | null;
  view_count: number;
  created_at: string;
  course_outline: any | null;
  lessons: any | null;
}

export const useCommunityTopics = (selectedTag?: string) => {
  return useQuery({
    queryKey: ['community-topics', selectedTag],
    queryFn: async () => {
      let query = supabase
        .from('community_topics')
        .select('id, title, description, tags, thumbnail_url, view_count, created_at, course_outline, lessons')
        .eq('published', true);
      
      const { data, error } = await query.order('view_count', { ascending: false });
      
      if (error) throw error;
      
      // Filter by tag on the client side
      if (selectedTag && selectedTag !== 'recommend' && selectedTag !== 'featured') {
        const filtered = data?.filter(topic => {
          return topic.tags?.includes(selectedTag);
        });
        return filtered || [];
      }
      
      return data || [];
    },
  });
};

export const useUniqueTags = () => {
  return useQuery({
    queryKey: ['community-tags'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('community_topics')
        .select('tags')
        .eq('published', true);
      
      if (error) throw error;
      
      // Extract all unique tags
      const tagsSet = new Set<string>();
      data?.forEach(topic => {
        topic.tags?.forEach((tag: string) => {
          if (tag) tagsSet.add(tag);
        });
      });
      
      return Array.from(tagsSet).sort();
    },
  });
};
